export default {
  universes: [],
  success: false,
  error: false,
  initialState: true,
};
